<app-form-mincoupons></app-form-mincoupons>
<div class="d-flex">
  <div class="col-12 my-1">
    <button id="create-variable" class="btn btn-indigo float-right" type="submit" (click)="create()">
      <span>
        Ajouter un Coupon
      </span>
    </button>
  </div>
</div>
<div class="basic-container" style="margin-top: 10px;">
  <table mat-table matSort [dataSource]="coupons" multiTemplateDataRows
  (matSortChange)="sortData($event)"
  multiTemplateDataRows class="mat-elevation-z8">
  <ng-container matColumnDef="expandIcon">
    <th mat-header-cell *matHeaderCellDef> </th>

    <!-- <td mat-cell *matCellDef="let element">
      <div class="flex-nowrap form-inline">
        <mat-icon (click)="expandedElement = expandedElement === element ? null : element">
          {{expandedElement === element ? 'expand_less' : 'expand_more'}}
        </mat-icon>
      </div>
    </td> -->
  </ng-container>
    <ng-container matColumnDef="expirationDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Date d'expiration </th>
      <td mat-cell *matCellDef="let element">
      <span >
          {{element.expirationDate | momentPipe:'DD/MM/YYYY'}}
      </span>
    </td>
    </ng-container>
    <ng-container matColumnDef="usedBy">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Temps </th>
      <td mat-cell *matCellDef="let element"> {{element.temps}} </td>
    </ng-container>
    <ng-container matColumnDef="note">
      <th mat-header-cell mat-sort-header  *matHeaderCellDef> Note </th>
      <td mat-cell *matCellDef="let element"> {{element.note}} </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
        <div class="buttons">
          <div class="m-2">
            <span (click)="edit(element)">
              <i class="fa fa-pencil-square-o text-primary" style="cursor: pointer;" aria-hidden="true"
                title="Editer"></i>
            </span>
          </div>
          <div class="m-2">
            <span (click)="openDeleteConfirm(element.id)">
              <i class="fa fa-trash-o text-danger" style="cursor: pointer;" aria-hidden="true" title="Supprimer"></i>
            </span>
          </div>
        </div>
      </ng-container>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row " >
    </tr>
  </table>
</div>

